module.exports = __webpack_public_path__ + "static/media/presion.e2458ae3.jpg";